const sw = {
    nav: {
      home: "Nyumbani",
      browse: "Vinjari Harusi",
      dashboard: "Dashibodi",
      messages: "Ujumbe",
      profile: "Wasifu",
      login: "Ingia",
      register: "Jisajili",
      logout: "Toka",
      admin: "Msimamizi",
      faq: "Maswali",
      about: "Kuhusu Sisi",
      contact: "Wasiliana",
      pricing: "Bei",
      howItWorks: "Inavyofanya Kazi",
    },
    auth: {
      login: {
        title: "Karibu Tena",
        email: "Barua pepe",
        password: "Nenosiri",
        button: "Ingia",
        noAccount: "Huna akaunti?",
        register: "Jisajili sasa",
      },
      register: {
        title: "Fungua Akaunti",
        name: "Jina Kamili",
        email: "Barua pepe",
        password: "Nenosiri",
        role: "Nataka...",
        roleHost: "Kuandaa harusi",
        roleGuest: "Kuhudhuria harusi",
        terms: "Ninakubali masharti na sera ya faragha",
        button: "Jisajili",
        hasAccount: "Una akaunti tayari?",
        login: "Ingia sasa",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Inapakia...",
      error: "Hitilafu imetokea",
      success: "Imefanikiwa",
      save: "Hifadhi",
      cancel: "Ghairi",
      delete: "Futa",
      edit: "Hariri",
      back: "Rudi",
      next: "Ifuatayo",
      language: "Lugha",
      currency: "Sarafu",
      search: "Tafuta",
      filter: "Chuja",
      all: "Zote",
      none: "Hakuna",
      yes: "Ndiyo",
      no: "Hapana",
    },
    footer: {
      about: "Kuhusu",
      privacy: "Faragha",
      terms: "Masharti",
      contact: "Wasiliana",
      copyright: "© 2024 WEDVAYA. Haki zote zimehifadhiwa.",
    },
  };

export default sw;
